import Http from '../Http';

const baseUrl = `${process.env.VAPI_BASE_URL}/adproviders`;

export default {
  list: (options = {}) => Http.get(baseUrl, options),
};
